import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {tickets,ticketingDiscount} = api

/**
 * 查找
 */
export async function findTickets(params) {
    return request({url: tickets, method: 'get', data: params,})
}
/**
 * 批量新增或编辑活动票务折扣
 */
export async function updateTicketingDiscount(params) {
    return request({url: ticketingDiscount, method: 'patch', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/ticket.js